export const Text = {
  baseStyle: {
    fontFamily: 'body',
    color: '#163A50',
  },
};
